var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Box, Button, Typography } from '@lucidlink/uicore';
import { LOG_LEVEL_CONFIG } from '../Logging.constants';
export const LogLevels = ({ disabled = false, filespaceClient, }) => {
    _react_refresh_temp_2();
    const [currentLogLevel, setCurrentLogLevel] = useState();
    useEffect(() => setCurrentLogLevel(filespaceClient?.getLogLevel()), [filespaceClient]);
    const setLogLevel = useCallback((logLevel) => {
        setCurrentLogLevel(logLevel);
        void filespaceClient?.setLogLevel(logLevel);
    }, [filespaceClient]);
    return (_jsx(Box, { gap: "sm", orientation: "horizontal", children: Object.entries(LOG_LEVEL_CONFIG).map(([logLevel, config]) => {
            const id = `${logLevel}-log-level`;
            const color = disabled ? 'default' : config.color;
            const isDisabled = disabled || currentLogLevel === logLevel;
            return (_jsx(Button, { "data-testid": id, disabled: isDisabled, kind: "secondary", onClick: () => setLogLevel(logLevel), size: "small", children: _jsx(Typography, { color: color, kind: "p", children: config.text }) }, id));
        }) }));
};
_react_refresh_temp_1 = LogLevels;
$RefreshReg$(_react_refresh_temp_1, "LogLevels");
_react_refresh_temp_2(LogLevels, "PB61tQ+2+Am9pCgDmKx7ll8OaTA=");
